import styled from 'styled-components';
import Container from '@/browser/Container';
import LiftGrid from '@/components/LiftCard/LiftGrid';
import GreyBox from '@/browser/GreyBox';

const Shopcontainer = styled(Container)`
  padding-top: 3em;
`;

const ProductHeading = styled.div`
  margin-bottom: 32px;
`;

const ProductGrid = styled(LiftGrid)`
  margin-bottom: 44px;
  ${(props) => props.theme.media.mobile`
    margin-bottom: 0;
  `}
`;

const ProductBox = styled(GreyBox)`
  margin-bottom: 86px;
  padding: 86px 100px;
  display: grid;
  grid-template-columns: repeat(2, 45%);
  grid-gap: 10%;
  ${(props) => props.theme.media.tablet`
    padding: 64px 40px;
  `};
  ${(props) => props.theme.media.mobileSmall`
    padding: 32px 16px;
    display: block;
  `};
`;

const ProductContent = styled.div`
  h2 {
    margin-bottom: 12px;
    padding-top: 12px;
  }
  .product-content {
    border-top: 1px solid
      ${(props) => props.theme.colors.kuluttaja2021.harmaa[10]};
    padding: 10px 0;
    margin-bottom: 16px;
  }
  ${(props) => props.theme.media.mobileSmall`
    padding-top: 32px;
  `};
`;

const UpsellProducts = styled.div`
  border-top: 1px solid
    ${(props) => props.theme.colors.kuluttaja2021.harmaa[10]};
  padding-top: 46px;
`;

export {
  Shopcontainer,
  ProductGrid,
  ProductBox,
  ProductContent,
  ProductHeading,
  UpsellProducts
};
